<template>
    <div id="confirmation-response">
        <img id="confirmation-tooth" src="../../images/confirmation-tooth.png">

        <div v-if="inactiveUser">
            <h1 class="thanks">
                Sprawdź pocztę i aktywuj konto, aby potwierdzić rezerwację wizyty.
            </h1>
            <p class="info">
                Aby placówka mogła potwierdzić Twoją wizytę, <span class="stress">kliknij w link aktywacyjny</span>,
                który został do Ciebie wysłany na wskazany adres e-mailowy. <br>
                Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź skrzynkę SPAM.
            </p>
            <p class="info">
                Po aktywacji konta wybrany przez Ciebie termin musi zostać potwierdzony przez placówkę,
                gdy się to stanie otrzymasz od nas powiadomienie.
            </p>
            <p class="info">
                W wiadomości aktywacyjnej wysłaliśmy również Twój login, który posłuży
                do logowania się do konta pacjenta.
            </p>
        </div>
        <div v-else-if="$store.facility.require_doctor_reservation_approval">
            <h1 class="thanks">Dziękujemy za rezerwację wizyty w naszym gabinecie</h1>
            <p class="info">Zarezerwowany termin musi zostać potwierdzony przez placówkę.<br>
            Na wskazany adres e-mailowy otrzymasz powiadomienie o akceptacji terminu.<br>
            Jeśli nie widzisz wiadomości w skrzynce odbiorczej, sprawdź skrzynkę SPAM.</p>
        </div>
        <div v-else>
            <h1 class="thanks">Dziękujemy za rezerwację wizyty w naszym gabinecie</h1>
        </div>

        <div>
            <button class="btn-outline-green" @click="goToIndex">UMÓW KOLEJNĄ WIZYTĘ</button>
            <button class="btn-outline-blue" @click="goToPatientsPortal">PRZEJDŹ DO SWOJEGO KONTA</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../css/colors.scss";

    #confirmation-response {
        text-align: center;

        .thanks {
            color: $blue;
            font-weight: 400;
            margin: 20px;
            margin-top: 10px;
        }

        .info {
            margin: 15px;
        }

        .stress {
            color: $btn-orange-color;
        }
    }
</style>

<script>
    import {
        PATIENTS_PORTAL_LOGIN_URL,
    } from '../constants.js'

    export default {
        name: 'ConfirmationResponse',
        props: {
            inactiveUser: {
                required: true,
                type: Boolean,
            },
        },
        methods: {
            goToIndex() {
                this.$router.push({name: 'index'});
            },
            goToPatientsPortal() {
                if (this.inIframe()) {
                    window.open('//' + window.location.host + PATIENTS_PORTAL_LOGIN_URL);
                } else {
                    window.location.href = '//' + window.location.host + PATIENTS_PORTAL_LOGIN_URL;
                }
            },
            inIframe() {
                try {
                    return window.self !== window.top;
                } catch (e) {
                    // Tricky hacky thing that can happen if iframe blocks origin
                    return true;
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// ConfirmationResponse.vue?b2512154